"use client";

import dynamic from "next/dynamic";

interface BannerMeta {
  id: string;
  title: string;
  link: string;
}

interface HeroCarouselClientProps {
  banners: BannerMeta[];
  locale: string;
  children: React.ReactNode;
}

const HeroCarouselEnhancer = dynamic(
  () => import("@/components/HeroCarouselEnhancer"),
);

export function HeroCarouselClient({ banners, locale, children }: HeroCarouselClientProps) {
  return (
    <HeroCarouselEnhancer banners={banners} locale={locale}>
      {children}
    </HeroCarouselEnhancer>
  );
}
